import React from 'react'

export default function({ text, onAccept, onDecline }) {
  return (
    <div className="disclaimer">
      <div
        className="disclaimer__text"
        dangerouslySetInnerHTML={{ __html: text }}
      />
      <div className="disclaimer__action">
        <button className="-decline" onClick={onDecline} data-loc="sbicookie">
          Decline
        </button>
        <button className="-accept" onClick={onAccept} data-loc="sbicookie">
          Accept & Get Started
        </button>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/welcome/disclaimer.js